import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import "./styles.css";
import { FloatingPortal, autoPlacement, autoUpdate, flip, offset, shift, useClick, useDismiss, useFloating, useInteractions, useRole, useTransitionStatus, useTransitionStyles, } from "@floating-ui/react";
import DropdownActions from "./components/DropdownActions";
import DropdownBody from "./components/DropdownBody";
import DropdownBodyPlaceholder from "./components/DropdownBodyPlaceholder";
import DropdownFooter from "./components/DropdownFooter";
import DropdownHeader from "./components/DropdownHeader";
import DropdownList from "./components/DropdownList";
import DropdownListPageable from "./components/DropdownListPageable";
import DropdownOverlay from "./components/DropdownOverlay";
import DropdownOverlayLoading from "./components/DropdownOverlayLoading";
import DropdownSearch from "./components/DropdownSearch";
function Dropdown({ children, overlay, forceClose, forceOpen, placement = "bottom-start", portal = true, onOpenChange }) {
    const [open, setOpen] = useState(forceOpen);
    const onOpenChangeHandler = () => {
        setOpen(!open);
        onOpenChange?.();
    };
    const { refs, floatingStyles, context } = useFloating({
        open,
        placement,
        middleware: [
            offset(5),
            flip(),
            shift(),
            autoPlacement({
                alignment: "start",
                allowedPlacements: ["top", "bottom"],
            }),
        ],
        whileElementsMounted: autoUpdate,
        onOpenChange: onOpenChangeHandler,
    });
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role]);
    const { isMounted } = useTransitionStatus(context);
    const { styles: animationStyles } = useTransitionStyles(context, {
        duration: {
            open: 200,
            close: 100,
        },
    });
    useEffect(() => {
        if (forceOpen)
            setOpen(true);
    }, [forceOpen]);
    useEffect(() => {
        if (forceClose)
            setOpen(false);
    }, [forceClose]);
    useEffect(() => {
        if (open) {
            refs.domReference.current?.classList.add("active");
        }
        else {
            refs.domReference.current?.classList.remove("active");
        }
    }, [open, refs.domReference]);
    return (_jsxs(_Fragment, { children: [typeof children === "string" ? (_jsx("div", { className: "max-w-fit", ref: refs.setReference, ...getReferenceProps(), children: children })) : (React.cloneElement(children, {
                ref: (node) => {
                    refs.setReference(node);
                },
                ...getReferenceProps(),
            })), !portal && isMounted && (_jsx(FloatingPortal, { children: _jsx("div", { style: { ...floatingStyles, ...animationStyles }, className: "z-dropdown shadow-dropdown", ref: refs.setFloating, ...getFloatingProps(), children: overlay }) })), portal && isMounted && (_jsx("div", { style: { ...floatingStyles, ...animationStyles }, className: "z-dropdown shadow-dropdown", ref: refs.setFloating, ...getFloatingProps(), children: overlay }))] }));
}
Dropdown.Header = DropdownHeader;
Dropdown.Actions = DropdownActions;
Dropdown.Body = DropdownBody;
Dropdown.Footer = DropdownFooter;
Dropdown.Overlay = DropdownOverlay;
Dropdown.Search = DropdownSearch;
Dropdown.ListPageable = DropdownListPageable;
Dropdown.List = DropdownList;
Dropdown.Loading = DropdownOverlayLoading;
Dropdown.Placeholder = DropdownBodyPlaceholder;
export default Dropdown;
